// Animation timings
export const ANIMATION_DURATION = {
  CORE_VALUE_TRANSITION: 500,
  SKELETON_FADE: 800,
  SSO_TIMEOUT: 4000,
  QUICK_SSO_TIMEOUT: 2000,
  CORE_VALUE_ROTATION: 10000,
} as const;

// Token buffer
export const TOKEN_BUFFER_MS = 5 * 60 * 1000; // 5 minutes

// Cache durations
export const CACHE_DURATION = {
  PROFILE_PICTURE: 3600, // 1 hour
  PET_IMAGE: 0, // No cache
} as const;

// LocalStorage keys
export const STORAGE_KEYS = {
  APP_CARD_ORDER: 'appCardOrder',
  APP_CARD_VIEW_MODE: 'appCardViewMode',
  PROFILE_PICTURE_PREFIX: 'profilePicture_',
} as const;

// API URLs
export const getApiUrl = () =>
  import.meta.env.PROD
    ? 'https://api.hub.duo.tax'
    : import.meta.env.VITE_BACKEND_URL || 'http://localhost:2001';

// Feature flags
export const FEATURES = {
  ENABLE_ADMIN_OVERRIDE: true,
  ENABLE_CORE_VALUES_BANNER: true,
} as const;

// Salesforce field names
export const SF_FIELDS = {
  TEAM: 'Team__c',
  SUBDIVISION: 'Staff_Subdivision__c',
  DIVISION_LEADER: 'Division_Leader__c',
  COMPANY: 'Company__c',
  JOINED_DATE: 'Joined_Date__c',
  DIVISION_LOCATION: 'Division_Location__c',
  PROFILE_PIC: 'dp_url__c',
} as const;
